import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 5 — Patrol (brief §6).
 *
 * The first Chimera in real content: a Creep, boxed between two short
 * pillars at row 9 (columns 6 and 12) so it walks a short, fully predictable
 * loop rather than the whole room. The canonical route is not to fight it or
 * wait it out - a three-step staircase, the same technique Room 1 taught,
 * reaches a stone ledge at row 7, well above the pillars, and the player
 * simply walks over it. "Route
 * around it" is literal: the same cast-and-climb skill from Room 1, now used
 * defensively.
 *
 * The ledge sits three rows above the Creep's floor (row 10), not two. A
 * Creep's "am I blocked" check examines *two* rows above its feet, not one -
 * a ledge two rows up still reads as a low ceiling and jams it in place on
 * the very first step. First built with the ledge at row 8; it deadlocked
 * the Creep instantly (dir flipped every tick, x never moved), traced with a
 * short standalone script, and fixed by re-reading updateCreep's own check
 * rather than guessing again.
 *
 * Clearing this room unlocks the Bramble Horn (brief §7): `App.tsx` reads
 * this room's id (`'05-patrol'`) out of the cleared-rooms set and, once
 * present, passes `{ brambleHorn: true }` into every `Simulation` from then
 * on. Nothing in this room's own definition drives that - the unlock lives
 * entirely in `App.tsx` and `sim.ts`'s `fireRanged`, bypassing the Tail
 * skill's ammo gate rather than changing anything about `cast`.
 *
 * SCAFFOLD CONTENT (brief §14), same as Rooms 1-4.
 */
export const patrol: RoomDef = {
  id: '05-patrol',
  name: 'Patrol',
  map: [
    '################',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#.......####...#',
    '#..............#',
    '#.....#.....#..#',
    '################',
    '################',
  ],
  spawn: { x: 3.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [{ kind: 'moonseed', tx: 13, ty: 9 }],
  chimera: [{ kind: 'creep', x: 9, y: 10, dir: 1 }],
};
